<template>
  <div>
    <v-dialog
      v-model="dialog"
      :max-width="paymentMethods[payment?.paymentMethod]?.maxWidth || '470px'"
      :persistent="!error"
      :overlay-opacity="0.5"
      content-class="rounded-lg"
    >
      <v-card :loading="loading" rounded="lg">
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <div v-if="error" class="pa-4">
          <v-alert type="error" class="mb-0">{{ error }}</v-alert>
        </div>
        <div v-if="payment && !error">
          <v-tabs
            v-if="tab !== null || availablePaymentMethods.length === 1"
            v-model="tab"
            background-color="transparent"
            color="primary"
            grow
            show-arrows
          >
            <v-tab
              v-for="({ paymentType }, index) in availablePaymentMethods"
              :key="index"
              :tab-value="paymentType"
            >
              <v-icon small left> {{ paymentTypes[paymentType].icon }} </v-icon>
              {{ paymentTypes[paymentType].name }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item :value="null" class="pa-6 pb-4">
              <SelectPaymentMethod
                :availablePaymentMethods="availablePaymentMethods"
                :payment="payment"
                @select="tab = $event"
                @close="close"
              />
            </v-tab-item>

            <v-tab-item
              v-for="{ paymentType, paymentMethod } in availablePaymentMethods"
              :key="paymentType"
              :value="paymentType"
            >
              <component
                :is="paymentMethods[paymentMethod][paymentType].component"
                :integrationData="integrationData"
                :bankRestriction="bankRestriction"
                :paymentId="paymentId"
                :payment="payment"
                :tickets="tickets"
                :party="party"
                @lock="lock"
                @update="getPayment"
                @refresh="$emit('refresh')"
                @close="close"
              />
            </v-tab-item>
          </v-tabs-items>
        </div>
        <!-- <component
          :is="paymentMethods[payment?.paymentMethod].component"
          :integrationData="integrationData"
          :paymentId="paymentId"
          :payment="payment"
          :tickets="tickets"
          :party="party"
          :bankRestriction="bankRestriction"
          @update="getPayment"
          @refresh="$emit('refresh')"
          @close="close"
        /> -->
      </v-card>
    </v-dialog>
    <fb-pixel v-if="party.fbPixelId" :fbPixelId="party.fbPixelId" />
  </div>
</template>

<script>
import TICKET from "@/services/app/ticket";
import SelectPaymentMethod from "../../../components/app/modals/payment/modules/SelectPaymentMethod.vue";
import FbPixel from "../../../components/global/FbPixel.vue";

// Pix
import GeneralPix from "../../../components/app/modals/payment/modules/GeneralPix.vue";

// Gateways
import CieloQRCode from "../../../components/app/modals/payment/modules/CieloQRCode.vue";
import CieloCreditCard from "../../../components/app/modals/payment/modules/CieloCreditCard.vue";
import PagseguroCreditCard from "../../../components/app/modals/payment/modules/PagseguroCreditCard.vue";
import PagarmeCreditCard from "../../../components/app/modals/payment/modules/PagarmeCreditCard.vue";

export default {
  components: {
    SelectPaymentMethod,
    GeneralPix,
    CieloQRCode,
    CieloCreditCard,
    PagseguroCreditCard,
    PagarmeCreditCard,

    FbPixel,
  },
  data: () => ({
    tab: null,
    dialog: false,
    loading: false,
    error: false,
    payment: null,
    locked: null,
    progressBar: {
      initial: 0,
      time: 0,
      interval: null,
    },
    paymentMethods: {
      // MERCADO_PAGO: {
      //   PIX: { component: "MercadoPagoPayment" },
      //   CREDIT_CARD: { component: "MercadoPagoPayment" },
      // },
      PAGSEGURO: {
        PIX: { component: "GeneralPix" },
        CREDIT_CARD: { component: "PagseguroCreditCard" },
      },
      CIELO: {
        PIX: { component: "GeneralPix" },
        CREDIT_CARD: { component: "CieloCreditCard" },
        maxWidth: "470px",
      },
      PAGARME: {
        PIX: { component: "GeneralPix" },
        CREDIT_CARD: { component: "PagarmeCreditCard" },
      },
    },
    paymentTypes: {
      PIX: {
        id: "PIX",
        icon: "mdi-qrcode",
        name: "PIX",
        component: "GeneralPix",
        description: "Pague com o seu aplicativo de banco",
      },
      CREDIT_CARD: {
        id: "CREDIT_CARD",
        icon: "mdi-credit-card",
        name: "Cartão de Crédito",
        component: "CieloCreditCard",
        description: "Pague com seu cartão de crédito",
      },
      QR_CODE: {
        id: "QR_CODE",
        icon: "mdi-wallet",
        name: "Carteira Digital",
        component: "CieloQRCode",
      },
    },
  }),
  methods: {
    close() {
      this.dialog = false;
      this.payment = null;
      this.error = false;
    },
    async open() {
      this.dialog = true;
      this.error = false;
      try {
        this.loading = true;
        await this.getPayment();
        this.loading = false;
        this.$root.$emit("initiate_checkout", {
          amount: this.payment.amount,
          Tickets: this.tickets,
        });
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.error = error.message;
      }
    },
    async getPayment() {
      const { payment, tickets, data } = await TICKET.getPayment(
        this.paymentId
      );
      this.payment = payment;
      this.tickets = tickets;
      this.integrationData = data;
    },
    lock(paymentType) {
      this.locked = paymentType;
    },
  },
  computed: {
    bankRestriction() {
      if (!this.tickets) return false;
      return this.tickets?.find((ticket) => ticket.TicketBlock?.BankRestriction)
        ?.TicketBlock?.BankRestriction;
    },
    availablePaymentMethods() {
      if (!this.payment) return [];
      var availablePaymentMethods = ["PIX", "CREDIT_CARD"];
      if (this.bankRestriction) availablePaymentMethods = ["CREDIT_CARD"];
      if (this.locked) availablePaymentMethods = [this.locked];

      return availablePaymentMethods
        .map((paymentType) => {
          const gateway = this.integrationData.gateways[paymentType];
          if (!gateway) return null;
          return {
            paymentType,
            paymentMethod: gateway,
          };
        })
        .filter((paymentMethod) => paymentMethod !== null);
    },
  },
  async mounted() {
    this.$parent.$on("pay", this.open);
  },

  props: {
    paymentId: {
      type: String,
      required: true,
    },
    tickets: {
      type: Array,
      required: true,
    },
    party: {
      type: Object,
      required: true,
    },
  },
};
</script>
